import PermittingModule from './index.vue';

// eslint-disable-next-line import/prefer-default-export
export const permittingRoutes = [
  {
    path: '/permitting',
    component: PermittingModule,
    children: [
      {
        path: 'permitapplication',
        name: 'PermitApplication',
        component: () => import('./pages/permit-application.vue'),
        meta: {
          showForAllLoggedUsers: true,
          showForGuestUsers: true,
        },
      },
      {
        path: 'STSRWP',
        name: 'STSRWP',
        component: () => import('./pages/select-muni.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      {
        path: 'STSWP',
        name: 'STSWP',
        component: () => import('./pages/select-muni.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      {
        path: 'STSRP',
        name: 'STSRP',
        component: () => import('./pages/select-muni.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },

    ],
  },
];
